jQuery(function($) {
  if(window.innerWidth < 1279) {
    $('.slick-reviews').slick({
      dots: true,
      arrows: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  }
});